import { useState } from "react";
import {BsCheckLg, BsPencilFill, BsTrash, BsXLg, BsThreeDotsVertical} from "react-icons/bs";
import { Form } from "react-bootstrap";
import { Dropdown } from "react-bootstrap";
import { TASK_UPDATE_CONTENT_URL, TASK_UPDATE_STATUS_URL } from "../../../utils/config";
import Spinner from "../../Spinner";
import CheckableSquare from "../../CheckableSquare";

export default function Activity({activity, deleteRequest, moveRequest}){
    
    const [editing, setEditing] = useState(false);
    const [value, setValue] = useState(activity.content)
    const [previousValue, setPreviousValue] = useState(activity.content);
    const [updating, setUpdating] = useState(false);
    const [error, setError] = useState("");
    const [isInvalid, setIsInvalid] = useState(false);
    const [checked, setIsChecked] = useState(activity.status === 1);
    const [updatingStatus, setUpdatingStatus] = useState(false);

    const handleEditClick = () =>{
        setEditing(true);
    };

    const handleDeleteRequest = () => {
        deleteRequest(activity);
    };

    const handleMoveRequest = () => {
        moveRequest(activity);
    }

    const handleSubmit = (e) =>{
        e.preventDefault();
        handleUpdateValue();
    }

    const handleContentChange = (e) => {
        setValue(e.target.value);
        setIsInvalid(false);
    }

    const handleUpdateValue = () => {
        
        if(value === "" || value.trim() === ""){
            setIsInvalid(true);
            setError("Debes ingresar contenido a la actividad.");
            return;
        }

        setUpdating(true);

        const url = TASK_UPDATE_CONTENT_URL + activity.id;
        const body = {
            id: activity.id,
            content: value,
            status: checked ? 1 : 0
        };
        fetch(url, {
            method: "PUT",
            headers: {
                "Content-type": "application/json;charset=UTF-8",
                //'Authorization': localStorage.getItem("authorization")
            },
                body: JSON.stringify(body),
        }).then(response => {
            if(response.ok) return response.json();
            if(response.status===400) return {error: "bad request"};
            if(response.status===401) return {error: "unauthorized"};
            return Promise.reject(response);
        }).then(json =>{
            if(json.error){
                console.error(json.error);
                return;
            }
            setPreviousValue(value);
            setEditing(false);
        }).catch(response =>{
            console.log("catch");
            console.log(response);
        }).finally(() => {
            setUpdating(false);
        });
    }

    const handleCancelEdition = () => {
        setValue(previousValue);
        setEditing(false);
        setError("");
        setIsInvalid(false);
    }

    const setAsDone = () => {
        updateDone(1);
    };

    const setAsUndone = () => {
        updateDone(0);
    };

    const updateDone = (status) =>{
        updateTask(status);
    }

    const updateTask = (status) =>{
        setUpdatingStatus(true);
        setError('');
        const url = TASK_UPDATE_STATUS_URL + activity.id;
        const body = {
            status: status
        };
        fetch(url,{
            method: "PUT",
            headers: {
                "Content-type": "application/json;charset=UTF-8",
                //'Authorization': localStorage.getItem("authorization")
            },
            body: JSON.stringify(body)
        })
        .then(response => {
            if(response.ok) return response.json();
            if(response.status===400) return {error: "bad request"};
            if(response.status===401) return {error: "unauthorized"};
            return Promise.reject(response);
        })
        .then(json =>{
            if(json.error){
                console.error(json.error);
                return;
            }
            setIsChecked(status===1);
        })
        .catch(response =>{
            console.log("catch");
            console.log(response);
        }).finally(() =>{
            setUpdatingStatus(false);
        })
    }

    return (
        <div className="activity-card">
            {
                editing
                ?<div className="editing">
                    {
                        updating
                        ?<>
                           <span className="content">{value}</span>
                           <Spinner /> 
                        </>
                        :<Form onSubmit={handleSubmit}>
                            <div className="width-100">
                                <Form.Control isInvalid={isInvalid} value={value} onChange={handleContentChange} />
                                {
                                    error &&
                                    <Form.Control.Feedback type="invalid">
                                        {error}
                                    </Form.Control.Feedback>
                                }
                            </div>
                            <div className="buttons">
                                <button type="button" className="btn icon-btn green" onClick={handleUpdateValue}><BsCheckLg /></button>
                                <button type="button" className="btn icon-btn red" onClick={handleCancelEdition}><BsXLg /></button>
                            </div>
                        </Form>
                    }
                </div>
                :<>
                    <div className="activity-status-container">
                        {
                            updatingStatus
                            ? <Spinner />
                            : <CheckableSquare done={checked} onCheck={setAsDone} onUncheck={setAsUndone} />
                        }                    
                    </div>
                    <span className="content" onDoubleClick={handleEditClick}>{value}</span>
                    <div className="buttons">
                        <button className="btn icon-btn" onClick={handleEditClick}><BsPencilFill /></button>
                        
                        <Dropdown>
                            <Dropdown.Toggle className="remove-triangle" variant="" id="dropdown-basic">
                                <BsThreeDotsVertical />
                            </Dropdown.Toggle>                           
                            <Dropdown.Menu>
                                <Dropdown.Item href="#" onClick={handleMoveRequest}>Mover al siguiente día</Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item href="#" className="text-danger" onClick={handleDeleteRequest}>Eliminar</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        
                    </div>
                </> 
            }
        </div>
    );
}